var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43334",
    "data-name": "Group 43334",
    transform: "translate(17364 -3990)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16072",
    "data-name": "Rectangle 16072",
    width: 24,
    height: 16,
    transform: "translate(-17364 3990)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_4_",
    "data-name": "right-arrow (4)",
    transform: "translate(-17363 3991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43333",
    "data-name": "Group 43333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37226",
    "data-name": "Path 37226",
    d: "M.184,133.923h0l6.332-6.332a.633.633,0,1,1,.893.893L2.16,133.739H21.48a.6.6,0,0,1,.6.629.609.609,0,0,1-.6.637H2.16l5.249,5.249a.633.633,0,1,1-.893.893L.184,134.816A.633.633,0,0,1,.184,133.923Z",
    transform: "translate(0 -127.369)",
    fill: "#b2b9c4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.d5c576cd1251f7444333ea5169b2461d.svg";
export { ForwardRef as ReactComponent };